import { Typography } from 'Components/atoms';
import { INTEGRATION_EARLY_ACCESS_CHIP_LABEL } from 'Core-utils/constants/constants';

const EarlyAccessIndicator = () => (
    <Typography variant="caption4" color="success-green" className="early-access-indicator">
        {INTEGRATION_EARLY_ACCESS_CHIP_LABEL}
    </Typography>
);

export default EarlyAccessIndicator;
